<template>
  <div
    v-if="displayProductSearch"
    ref="componentWrapper"
    class="sp__search__content"
  >
    <form
      class="sp__search__form"
      method="post"
      role="search"
      @submit.prevent="handleSubmit"
    >
      <div
        class="sp__search__form__product-id__wrap"
        :aria-label="translations.productFlowAriaLabel"
      >
        <div class="sp__search__form__label-wrapper">
          <label for="product_search_input">
            {{ translations.productFlowInput }}
          </label>
        </div>
        <!-- eslint-disable max-len -->
        <span class="sp__search__form__product-id-wrap">
          <input
            id="product_search_input"
            ref="autocompleteInput"
            type="text"
            name="product_id"
            :placeholder="translations.productFlowPlaceholder"
            class="sp__search__form__product-id sp__search__form__input"
            :class="{ error: error }"
            data-hj-whitelist
            :value="errorSearchTerm ? errorSearchTerm : internalSearchTerm"
            @input="onProductSearchChange"
          >
          <!-- eslint-enable max-len -->

        </span>

        <button type="submit">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 10 16"
          >
            <title>{{ translations.productFlowButtonTitle }}</title>
            <path d="M5.7 8L0 13.8 2.1 16 10 8 2.1 0 0 2.2 5.7 8z" />
          </svg>
        </button>
      </div>
      <div
        v-if="genericError"
        class="sp__search__form__error"
      >
        {{ translations.productFlowGenericError }}
      </div>
      <div
        v-if="faqSideDoorSearchError"
        class="sp__search__form__error"
        v-html="getFaqSideDoorSearchError"
      />
      <div
        v-if="specificityErrorMessage"
        class="sp__search__form__error"
      >
        {{ translations.productFlowSpecificityErrorDesc }}

        <a
          :href="translations.productFlowSpecificityErrorLink"
          @click.prevent="onHelpLinkClick({
            event_label: 'Specificity', link: translations.productFlowSpecificityErrorLink
          })"
        >
          {{ translations.productFlowSpecificityErrorActionText }}
        </a>
      </div>
      <div
        v-if="zeroResultsErrorMessage"
        class="sp__search__form__error"
      >
        {{ translations.productFlowZeroResultsErrorDesc }}
        <a
          :href="translations.productFlowZeroResultsErrorLink"
          @click.prevent="onHelpLinkClick({
            event_label: 'Zero Result', link: translations.productFlowZeroResultsErrorLink
          })"
        >
          {{ translations.productFlowZeroResultsErrorActionText }}
        </a>
      </div>
      <div
        v-if="errorOverrideMessage"
        class="sp__search__form__error"
      >
        {{ errorOverrideMessage.errorDescription }}

        <a
          :href="`${baseUrl}?faq=${errorOverrideMessage.faqIdentifier}`"
          @click.prevent="onHelpLinkClick({
            event_label: `Custom Error - ${errorSearchTerm}`, link: `${baseUrl}?faq=${errorOverrideMessage.faqIdentifier}`
          })"
        >
          {{ errorOverrideMessage.actionText }}
        </a>
      </div>
      <slot
        name="productIdentificationHelpLink"
        :slot-props="{translations}"
      >
        <ul class="sp__search__tooltip__link">
          <li>
            <a
              href="#"
              @click.prevent="toggle();
                              triggerAnalytics('Help Link - Product Identification', 'Product Selector - Link');"
            >
              {{ translations.productSearchTransitionInformationLabel }}
            </a>
          </li>
        </ul>
        <p
          v-show="isToolTipClicked"
          class="sp__search__tooltip__description"
        >
          {{ translations.productSearchTransitionInformationText }}
          <a
            target="_blank"
            :href="translations.productSearchTransitionInformationFaqLink"
            @click.prevent="onHelpLinkClick({ link: translations.productSearchTransitionInformationFaqLink, });
                            triggerAnalytics('Help Link - More Help', 'Product Selector - Link');"
          >
            {{ translations.productSearchTransitionInformationFaqLinkText }}
          </a>
        </p>
      </slot>
    </form>

    <ul
      v-if="!customProps.hideProductIdentificationHelpLinks"
      class="sp__search__help"
    >
      <li>
        <a
          :href="translations.noProductFlowLink"
          @click.prevent="onNoProductFlowClick();"
        >
          {{ translations.changeSearchType }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script src="./product-search.mjs"></script>
